if (!customElements.get('bird-image-comparison')) {
  customElements.define(
    'bird-image-comparison',
    class BirdImageComparison extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.range = this.querySelector('.bird-comparison__range');
        if (!this.range) return;

        this.dataset.initialized = 'true';
        this.update = this.update.bind(this);
        this.range.addEventListener('input', this.update);
        this.update();
      }

      disconnectedCallback() {
        this.range?.removeEventListener('input', this.update);
      }

      update() {
        const position = Math.min(100, Math.max(0, Number(this.range.value) || 0));
        this.style.setProperty('--bird-comparison-position', `${position}%`);
        this.range.setAttribute('aria-valuetext', `${position} percent of the field image visible`);
      }
    }
  );
}
